import React, {useState} from 'react';
import Modal from "../../components/modal/modal";
import styles from "../../styles/main.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faX} from "@fortawesome/free-solid-svg-icons";
import Loading from "../../components/loading/loading";
import axiosInstance from "../../AxiosInstance";
import {toast} from "../../components/toasts/toast/toast";
import { closeFinancingConfirm } from '../bus/modalApi';

export default function ConfirmFinancingModal({show, setter, quoteData, selectedInvoice}) {
    const [canAccept, setCanAccept] = useState(true);

    const parseValue = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const accept = () => {
        console.log(selectedInvoice);
        if(canAccept) {
            toast("Operación Creada")
            setCanAccept(false);
            axiosInstance.post(`financing/${selectedInvoice?.id}/create_operation/`, {
                currency: selectedInvoice.currency.code,
                debtor_ruc: selectedInvoice.purchase_order.client.ruc,
                debtor_name: selectedInvoice.purchase_order.client.name,
                seller_uuid: localStorage.getItem('seller_uuid').toString()
            }).then(() => {
                closeFinancingConfirm();
                setCanAccept(true);
                window.location.reload();
            })
        }
    }

    return (
        <Modal show={show} setter={setter} onClick={() => accept()} name={'Aceptar'} buttonName={'Aceptar'}>
            <div className={'mb-3'}>¿Desea que esta factura pueda ser enviada a factoring?</div>
        </Modal>
    )
}
